import React from 'react';

const Loading = () => {
    return (
        <div className='flex justify-center items-center min-h-screen'>
            <button className="btn btn-square btn-primary loading"></button>
        </div>
    );
};

export default Loading;